import styled from "styled-components";
export const BottomAdvice = styled.div`
    margin-top: 40px;
    width: 700px;
    line-height: 24px;
    @media only screen and (max-device-width: 812px) {
        width: 100%;
        padding: 24px;
    }
`;
export const AttentionIconContainer = styled.div`
    position: relative;
    display: inline;
    margin-right: 3px;
    width: 14px;
    & svg {
        position: relative;
        top: 2px;
    }
`;